/**
 * Credential read for the admin sign-in form.
 *
 * The form's inputs are React-controlled, but a password manager autofills the
 * DOM without reliably firing onChange — so the controlled values can still be
 * empty while the fields visibly show credentials. Submitting those sent a
 * blank password, Firebase answered auth/invalid-credential, and the page said
 * "Incorrect Email or password". Retyping to retry synced the state, which is
 * why the second attempt always worked.
 *
 * Reading the FormData makes the DOM authoritative, with the controlled values
 * only as a fallback for a field the form did not carry.
 */
export interface Credentials {
  email: string;
  password: string;
}

export function readCredentials(data: FormData, fallback: Credentials): Credentials {
  const formEmail = data.get("email");
  const formPassword = data.get("password");
  return {
    // A present-but-empty field means the user really did leave it blank, so
    // only fall back when the form carried no value for it at all.
    email: (typeof formEmail === "string" ? formEmail : fallback.email).trim(),
    password: typeof formPassword === "string" ? formPassword : fallback.password,
  };
}
